export const PAYMENT_TYPE_MAP: any = {
    0: "Advance",
    1: "To Pay"
};

export const PAYMENT_STATUS = {
    LOADING: "LOADING",
    PAID: "PAID"
};

export const EXPECTED_AMOUNT_TYPE: any = {
    0: "Fixed Price",
    1: "Per Tonne"
};

export enum ExpectedAmountType {
    FIXED_PRICE,
    PER_TONNE
}

export enum ExpectedAmountTypeNameMapping {
    FIXED_PRICE = "Fixed",
    PER_TONNE = "Per Tonne"
}

export enum PAYMENT_TYPE {
    Advance,
    ToPay
}
